import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: 'ri-search-eye-line',
      title: 'Ricerca prodotti intelligente',
      desc: 'Trova rapidamente prodotti interessanti organizzati per categoria con filtri avanzati e suggerimenti personalizzati.',
    },
    {
      icon: 'ri-file-info-line',
      title: 'Informazioni dettagliate',
      desc: 'Analizza prezzo, qualità, recensioni e caratteristiche di ogni prodotto prima dell\'acquisto.',
    },
    {
      icon: 'ri-camera-line',
      title: 'QC Photos',
      desc: 'Controlla immagini reali e foto di qualità prima di prendere una decisione d\'acquisto.',
    },
    {
      icon: 'ri-global-line',
      title: 'Guida italiana',
      desc: 'Tutte le informazioni spiegate in lingua italiana, create per le esigenze degli utenti italiani.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          {t('trust.title', 'Perché migliaia di utenti cercano Itaobuy Spreadsheet?')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card, idx) => (
            <div key={idx} className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300 mb-4">
                <i className={`${card.icon} text-xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">{card.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}